import { FormControl } from "../../../../_components/Forms/FormControl";
import { HorizontalView } from "../../../../_components/Abstractions/HorizontalView";

export function UsedSubContainerForm({ name }) {
  const GetFullField = (field) => `${name}.${field}`;

  return <>
    <HorizontalView>
      <FormControl name={GetFullField("containerName")} label="Podtyp kontenera" readonly/>
      <FormControl name={GetFullField("usedCount")} label="Liczba używanego podtypu" inputType="numeric"/>
    </HorizontalView>
  </>;
}